import React, {useEffect, useState} from "react";
import Loading from "../../components/Loading/Loading";
import useProfileBoostService from "../../api/services/useProfileBoostService";
import Button from "../../components/Button/Button";
import ProfileBoostIcon from "../../assets/icons/profile-boost-white.svg"
import useFunction from "../../hooks/useFunction";
import StandIcon from "../../assets/icons/stand-white.svg"
import SpotGroupIcon from "../../assets/icons/spot-group-white.svg"
import CreditsIcon from "../../assets/icons/credits.svg"
import ProfileBoostWhiteIcon from "../../assets/icons/profile-boost.svg"

const UserProfileBoosts = () => {

  const {userShowCollection} = useProfileBoostService()
  const [profileBoosts, setProfileBoosts] = useState([])
  const [isLoading, setIsLoading] = useState(true)
  const {dateTime, truncate} = useFunction()

  useEffect(() => {
    userShowCollection(
      (profileBoosts) => {
        setProfileBoosts(profileBoosts)
        setIsLoading(false)
      },
      (errors) => {
        setIsLoading(false)
      },
    )
  }, [])

  return (
    <div className="page-user-profile_boosts">
      <h1>Profiel omhoog plaatsen</h1>
      <p>Door je profiel omhoog te plaatsen, wordt het 1 week lang hoger in de zoekresultaten op de homepagina
        getoond, voor € 10,- of betaal met credits! <img src={CreditsIcon} alt="Stand credits" width={20}/></p>
      <Button
        label="Boost profiel voor 1 week"
        link="/wizard/boost"
        color="blue"
        icon={ProfileBoostIcon}
      />
      {isLoading
        ? <Loading/>
        : <div>
          {profileBoosts.length === 0 ?
            <p>Geen boosts actief op dit moment</p>
            :
            <div className="profile_boosts">
              {profileBoosts.map((profileBoost, i) => {
                return (
                  <div className="row profile_boost" key={i}>
                    <div className="col is-active">
                      {(profileBoost.ongoing && profileBoost.is_paid)
                        ? <img src={ProfileBoostWhiteIcon} alt="Deze profiel boost is actief" width={40}/>
                        : <span>Niet actief</span>
                      }
                    </div>
                    <div className="col date">Begin op: {dateTime(profileBoost.start_at)}</div>
                    <div className="col date">Eind op: {dateTime(profileBoost.end_at)}</div>
                    <div className="col button">
                      {profileBoost.stand &&
                        <Button
                          label={"Stand: " + truncate(profileBoost.stand.label, 12)}
                          size="s"
                          icon={StandIcon}
                        />
                      }
                      {profileBoost.spot_group &&
                        <Button
                          label={"Locatie: " + truncate(profileBoost.spot_group.label, 10)}
                          size="s"
                          icon={SpotGroupIcon}
                        />
                      }
                    </div>
                  </div>
                )
              })}
            </div>
          }
        </div>
      }
    </div>
  )
}

export default UserProfileBoosts
